import { renderRightHeaderItems as lazyItems } from 'component/common/Header/GetRightRenderMethod/GetRightLazyHeaderItems';
import { renderRightHeaderItems } from 'component/common/Header/GetRightRenderMethod/GetRightHeaderItems';
import { renderRightHeaderItems as defaultItems } from 'component/common/Header/GetRightRenderMethod/GetRightHeaderDefaultItems';
import { MENU_ITEM } from 'core/type/behaviors.types';

const MENU = {
    [MENU_ITEM.LAZY_ITEM]: lazyItems,
    [MENU_ITEM.AGODA_HEADER_ITEM]: renderRightHeaderItems,
    [MENU_ITEM.DEFAULT_ITEM]: defaultItems,
};

export const getRightRenderMethod = (menuItemType: MENU_ITEM) => MENU[menuItemType];
